export const SET_CREDIT_BALANCE = "SET_CREDIT_BALANCE";
